import { useState, useEffect } from "react";
import { getAdminTypeCookie } from "../../views/Login/cookie";

const useAdminType = () => {
	const [adminType, setAdminType] = useState("");

	useEffect(() => {
		const adminTypeFromSessionStorage = sessionStorage.getItem("adminType");
		if (adminTypeFromSessionStorage) {
			setAdminType(adminTypeFromSessionStorage);
		} else {
			const adminTypeFromCookie = getAdminTypeCookie();
			if (adminTypeFromCookie) {
				setAdminType(adminTypeFromCookie);
			}
		}
	}, []);

	return adminType;
};

export default useAdminType;
